// extracted by mini-css-extract-plugin
export default {"stat":"stat_stat__85Jsy","thin":"stat_thin__P0fB-"};